import { createContext, useContext, useEffect, useReducer } from "react";
import PropTypes from 'prop-types';
import apiClient from "../api/base";
import api from "../api/api";

// Définition du contexte
const DataContext = createContext(null);

// Actions
const ACTIONS = {
  ADD: "ADD",
  UPDATE: "UPDATE",
  DELETE: "DELETE",
  SET: "SET",
};

// Reducer pour gérer les actions
const dataReducer = (state, action) => {

  switch (action.type) {
    
    case ACTIONS.ADD:
      return { ...state, users: [...state.users, action.payload] };
    
    case ACTIONS.UPDATE:
      return {
        ...state,
        users: state.users.map((user) =>
          user.id === action.payload.id ? { ...user, ...action.payload } : user
        ),
      };

    case ACTIONS.DELETE:
      return { ...state, users: state.users.filter((user) => user.id !== action.payload) };

    case ACTIONS.SET:
      return { ...state, users: action.payload };

    default:
      return state;
  }
};

// Fournisseur de contexte
export const DataProvider = ({ children }) => {

  const [state, dispatch] = useReducer(dataReducer, { users: [], category : [] });


  // Fonctions pour manipuler les données
  const updateItem = (user) => dispatch({ type: ACTIONS.UPDATE, payload: user });
  const deleteItem = (id) => dispatch({ type: ACTIONS.DELETE, payload: id });
  const setItems = (users) => dispatch({ type: ACTIONS.SET, payload: users });



  return (
    <DataContext.Provider value={{ user : state.users, updateItem, deleteItem, setItems }}>
      {children}
    </DataContext.Provider>
  );
};



DataProvider.propTypes = {
  children: PropTypes.node.isRequired,
};


export const useDataContext = () => {
  const context = useContext(DataContext);
  if (!context) throw new Error("useDataContext must be used within a DataProvider");
  return context;
};
